export default __webpack_public_path__ + "static/media/vedant.bbf55216.jpg";